import { Descriptions, Tag } from "antd";
import React from "react";
import { connect } from "react-redux";
import ModalItem from "../../../../Components/ModalItem";
import dineroDisabledMask from "../../../../Components/dineroDisabledMask";
import TablaMatricesPreCotizacion from "../TablaMatricesPreCotizacion/TablaMatricesPreCotizacion";
import { formatearTiempoCiclo } from "../../PresupuestosPU/OrdenesDeProduccionPU/PlaneacionProduccionPU/planeacion.utils";

const ModalVerMatriz = ({ visible, matriz, onCerrar, unidadTiempoProduccion }) => (
  <ModalItem title={matriz ? `Matriz ${matriz.clave || matriz.descripcion}` : "Matriz"} visible={visible} onCancel={onCerrar} footer={null} width="80%" paddingTop>
    {matriz && (
      <>
        <Descriptions size="small" column={3} style={{ marginBottom: 12 }}>
          <Descriptions.Item label="Clave">{matriz.clave || "—"}</Descriptions.Item>
          <Descriptions.Item label="Descripción">{matriz.descripcion}</Descriptions.Item>
          <Descriptions.Item label="Unidad">{matriz.unidad || "—"}</Descriptions.Item>
          <Descriptions.Item label="Costo">{dineroDisabledMask(matriz.costo)}</Descriptions.Item>
          <Descriptions.Item label="Tiempo ciclo">{formatearTiempoCiclo(matriz.tiempoCiclo || 0, unidadTiempoProduccion)}</Descriptions.Item>
          <Descriptions.Item label="Versión">
            <Tag color="blue">v{matriz.versionNumero || 1}</Tag>
            <Tag color={matriz.autorizado ? "green" : "orange"}>{matriz.autorizado ? "Autorizada" : "Borrador"}</Tag>
          </Descriptions.Item>
        </Descriptions>
        <TablaMatricesPreCotizacion
          matrices={[{ ...matriz, piezas: 1 }]}
          soloLectura
          etiquetaCantidad="Cantidad"
          expandirTodo
          unidadTiempoProduccion={unidadTiempoProduccion}
        />
      </>
    )}
  </ModalItem>
);

const mapStateToProps = (state) => ({
  unidadTiempoProduccion: state.empresa.unidadTiempoProduccion,
});

export default connect(mapStateToProps)(ModalVerMatriz);
